// export const apiUrl = 'http://127.0.0.1:8000';

export const apiUrl = 'http://139.59.15.241:8001';

// export const imgUrl = 'http://127.0.0.1:8000';

export const imgUrl = 'http://139.59.15.241:8001';